import { render } from "./Zone.vue?vue&type=template&id=5c3c0b06"
import script from "./Zone.vue?vue&type=script&lang=js"
export * from "./Zone.vue?vue&type=script&lang=js"

import "./Zone.vue?vue&type=style&index=0&id=5c3c0b06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__